import { render, staticRenderFns } from "./TagValueEdit.vue?vue&type=template&id=f3fe2be4&scoped=true"
import script from "./TagValueEdit.vue?vue&type=script&lang=js"
export * from "./TagValueEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fe2be4",
  null
  
)

export default component.exports